/**
 * assets/product-preorder-notify.js
 * Preorder-meldknop in de buy-box van snippets/product-buy-box.liquid
 *
 * Verbergt de secundaire meldknop zodra het artikel in de winkelwagen zit.
 * Zie ARCHITECTURE.md sectie 11.
 */

(function () {
  var wrap = document.querySelector('[data-preorder-secondary]');
  if (!wrap) return;
  var toggle = wrap.querySelector('[data-preorder-notify-toggle]');
  var panel = wrap.querySelector('[data-preorder-notify-panel]');
  if (toggle && panel) {
    toggle.addEventListener('click', function () { panel.classList.toggle('hidden'); });
  }
  function hideSecondary() { wrap.style.display = 'none'; }
  var form = wrap.closest('form');
  if (form) { form.addEventListener('submit', function () { setTimeout(hideSecondary, 50); }); }
  document.addEventListener('cart:refresh', hideSecondary);
})();
